import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';
import { LabsterStore } from '@zg-rentals/particles-js-labster';
import address from './address';
import analytics from './analytics';
import app from './app';
import emailVerification from './emailVerification';
import lead from './lead'; // use alias
import modal from './modal';
import notification from './notification';
import properties from './properties';
import reviews from './reviews';
import statistic from './statistic';
import user from './user';
import paidInclusion from './paidInclusion';
import env from './env';
import billing from './billing';
import userManagement from './userManagement';
import singleFamilyEnterprise from './singleFamilyEnterprise';
import claimListings from './claimListings';
import zillowSubscription from './zillowSubscription';
import rentGuarantee from './rentGuarantee';

const rootReducer = history => combineReducers({
    address,
    analytics,
    app,
    env,
    emailVerification,
    singleFamilyEnterprise,
    LabsterStore,
    lead,
    modal,
    notification,
    properties,
    reviews,
    paidInclusion,
    statistic,
    user,
    billing,
    userManagement,
    claimListings,
    zillowSubscription,
    rentGuarantee,
    router: connectRouter(history),
});

export default rootReducer;
